<template>
  <div>
    <b-navbar type="light" class="ufo-green" toggleable="md">
      <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_dropdown_collapse">
        <b-navbar-brand to="/">
        <img src="@/assets/img/ufo_logo.svg" alt="Home" width="30" height="30">
        </b-navbar-brand>
        <b-navbar-nav>
          <b-nav-item to="/map">Map</b-nav-item>
          <b-nav-item to="/misc">Misc.</b-nav-item>
          <b-nav-item to="/about">About</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-text right>
            <small>
              <span v-for="(items, key) in filters" :key="key">
                <template  v-if="items.length > 0">
                  {{ key }}:
                  <span v-for="item in items" :key="item"
                    class="badge badge-pill badge-secondary mr-1">
                    {{ item }}
                  </span>
                </template>
              </span>
              <a href @click.prevent="clearFilters()">Clear filters</a>
            </small>
          </b-nav-text>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import defaultFilters from '@/assets/misc/default-filters';

export default {
  props: ['value'],
  computed: {
    filters() {
      return { ...this.value };
    },
  },
  methods: {
    clearFilters() {
      this.$emit('input', { ...defaultFilters });
    },
  },
};
</script>
